/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import NewTable from '../../components/NewTable/NewTable';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import Pagination from '../../components/Pagination/Pagination';
import { alertActions, coinManagementActions } from '../../_actions';
import { FaRegCopy, FaRegEye } from 'react-icons/fa';
import ViewHistory from '../AddFundExpressHistory/Components/ViewHistory';
import Loader from '../../components/Atoms/Loader';
import useDebounce from '../../Custom Hooks/Debounce';
const size = 10
const ExpressCheckoutHistory = () => {
  const [historyData, setHistoryData] = useState([])
  const dispatch = useDispatch()
  const selector = useSelector(state => state)
  const { getCoin: { getAllFiatCurrency } } = selector ? selector : {}

  const [searchTerm, setSearchTerm] = useState('');
  const [pageNo, setPageNo] = useState(1)
  const [fromDate, setFromDate] = useState("")
  const [toDate, setToDate] = useState('')
  const [sortBy, setSortBy] = useState('ALL');
  const [count, setCount] = useState([])
  const [isViewModal, setIsViewModal] = useState(false)
  const [viewData, setViewData] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [totalCount, setTotalCount] = useState(null)
  const [selectedValue, setSelectedValue] = useState(null)
  const debounce=useDebounce(searchTerm,500)

  useEffect(() => {
    function getCountList() {
      coinManagementActions.getAmountAndCount({ type: "ADD_FUNDS_EXPRESS_HISTORY" }).then((res) => {
        if (res) {
          setCount(res?.data)
        }
      }).catch((err) => console.log(err))
    }
    getCountList()
    dispatch(coinManagementActions.getAllFiatCurrency())

  }, []);


  const modifiedData = [
    { value: "", label: "Sort By Currency" },
    ...(getAllFiatCurrency || []).map((ele) => ({
      value: ele?.name,
      label: `Sort By ${ele?.symbol} - ${ele?.name}`
    }))
  ];

  const sortingOptions = [
    { value: 'ALL', label: 'Sort by All' },
    { value: 'pending', label: 'Sort by Pending' },
    { value: 'completed', label: 'Sort by Completed' },
    { value: 'failed', label: 'Sort by Failed' },
    { value: 'rejected', label: 'Sort by Rejected' },
  ];


  useEffect(() => {
    const data = {
      keyWord: debounce,
      fromDate: fromDate,
      toDate: toDate,
      pageNo: pageNo,
      size: size,
      status: sortBy,
      fiatCurrency: selectedValue ? selectedValue : "", expressType: 'express-merchant'
    }
    dispatch(coinManagementActions.buyPkrdHistory(data))
  }, [pageNo, size, sortBy, fromDate, toDate, debounce, selectedValue])

  useEffect(() => {
    setHistoryData(selector?.getCoin?.getPkrdHistoryList?.data?.list)
    setTotalCount(selector?.getCoin?.getPkrdHistoryList?.data?.total)
  }, [pageNo, selector, fromDate, toDate, dispatch])

  const handleSortByStatus = (e) => {
    const selectedSort = e.target.value;
    setSortBy(selectedSort);
  };
  const statusStyles = {
    pending: 'bg-[#FFA600]',
    completed: 'bg-[#02BC7D]',
    failed: 'bg-[#F6465D]',
    rejected: 'bg-[#F6465D]'
  };
  const tableHeadings = ["User", 'Currency', 'Order ID', 'Fiat', 'Fees', 'Collections(PKRD)', 'Status', 'Date', 'Action']
  const tableRows = historyData?.map((ele, index) => {
    const totalFee = (Number(ele?.networkFee || 0) + Number(ele?.knowledgeFee || 0) + Number(ele?.innovationFee || 0)).toFixed(4);

    return [
      <div>
        <p className='text-black'>{ele?.userId?.name}</p>
        <p>{ele?.userId?.email}</p>
      </div>,
      ele?.fiatCurrency,
      <div className='flex justify-start items-center gap-2'>
        {ele?.orderId?.slice(-8) || 'N/A'}
        <FaRegCopy className='cursor-pointer text-green-500' onClick={() => handleCopy(ele?.orderId)} />
      </div>,
      // <span>
      //   {(ele?.expressAmount).toFixed(4)} {ele?.fiatCurrency}
      // </span>,
      <span>
        {ele?.fiatAmount} {ele?.fiatCurrency}
      </span>,
      totalFee,
      (ele?.amount ?? 0).toFixed(4) ?? "N/A",
      <div className="flex items-center capitalize">
        <div className={`w-1 h-4 mr-2 rounded-md ${statusStyles[ele?.status] || 'bg-gray-500'}`}>
        </div>
        {ele?.status}
      </div>,
      <span className="">
        {moment(ele?.createdAt).format("MMMM Do YYYY, h:mm:ss a")}
      </span>,
      <span onClick={() => handleViewPkrdDetails(ele)}>
        <FaRegEye className="text-[22px] text-blue-500" title='View' />
      </span>
    ];
  });

  const handleCopy = (text) => {
    if (text) {
      navigator.clipboard.writeText(text)
        .then(() => {
          dispatch(alertActions.success("Order ID copied to clipboard."))
        })
        .catch((err) => {
          console.error('Failed to copy:', err);
        });
    }
  };



  const summaryDataFull = {
    sent: { amount: (count?.totalAmount ?? 0).toFixed(4), fees: (count?.totalFee ?? 0).toFixed(4) },
    received: { amount: '88,002.000', fees: '100,990.000' }
  };

  const onPageChange = page => {
    setPageNo(page)
  };


  const handleDateRangeChange = (start, end) => {
    setFromDate(start);
    setToDate(end);
  }

  const handleViewPkrdDetails = async (data) => {
    setIsViewModal(true)
    setIsLoading(true)

    try {
      const response = await coinManagementActions.getBuyPkrdDetails({ id: data?._id })
      if (response?.data) {
        setViewData(response.data)
      }
    } catch (error) {
      dispatch(alertActions.error(error))
    } finally {
      setIsLoading(false)
    }
  }

  const toggleModal = () => {
    setIsViewModal(false)
    setViewData(null)
  }

  const handleCurrencyOnChange = (e) => {
    console.log(e)
    setSelectedValue(e.target.value)
  }

  return (
    <div className='p-4 overflow-hidden overflow-y-auto'>
      <Loader loading={selector?.getCoin?.loading || isLoading} />
      <NewTable
        Heading={`Express Checkout History (${totalCount}) `}
        walletId={selector?.getCoin?.getPkrdHistoryList?.data?.total}
        tableHeadings={tableHeadings}
        data={tableRows}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        showSearch={true}
        placeholder="Search by amount"
        summaryDataFull={summaryDataFull}
        sentTitle={"Total PKRD"}
        showSorting={true}
        showAddButton={false}
        onSortByStatus={handleSortByStatus}
        sortStatusValue={sortBy}
        sortingOptions={sortingOptions}
        fromDate={fromDate}
        setFromDate={setFromDate}
        setToDate={setToDate}
        toDate={toDate}
        showDateFilter={true}
        showPageTopData1={true}
        showPageTopData2={false}
        showPageTopData3={true}
        showPageTopData4={false}
        handleDateRangeChange={handleDateRangeChange}
        showDropDown1={true}
        showDropDown2={true}
        sortingOptions2={modifiedData}
        onSortByStatus2={handleCurrencyOnChange}
        sortStatusValue2={selectedValue}
      />
      {Math.ceil(selector?.getCoin?.getPkrdHistoryList?.data?.total / size) >
        1 && (
          <Pagination
            totalPages={Math.ceil(
              selector?.getCoin?.getPkrdHistoryList?.data?.total / size
            )}
            currentPage={pageNo}
            onPageChange={onPageChange}
            total={selector?.getCoin?.getPkrdHistoryList?.data?.total}
          />
        )}

      <ViewHistory isOpen={isViewModal} data={viewData} onClose={toggleModal} heading={`View Info`} />
    </div>
  );
};

export default ExpressCheckoutHistory